import { diffLines, type DiffLine } from './diff'
import './DiffView.css'

/// Unified line-level diff. Roughly matches the SwiftUI Edit-tool view
/// that colors removed lines red and added lines green, with a left-edge
/// "-" / "+" marker and no marker on context lines.
export function DiffView({ before, after }: { before: string; after: string }) {
  const lines = diffLines(before, after)
  if (lines.length === 0) return null
  return (
    <div className="diff">
      {lines.map((line, i) => (
        <DiffRow key={i} line={line} />
      ))}
    </div>
  )
}

function DiffRow({ line }: { line: DiffLine }) {
  return (
    <div className={`diff__row diff__row--${line.kind}`}>
      <span className="diff__marker">
        {line.kind === 'add' ? '+' : line.kind === 'remove' ? '−' : ' '}
      </span>
      <span className="diff__text">{line.text || ' '}</span>
    </div>
  )
}
